class DispatchablePayload {
	constructor(source) {
		this.failed_dispatch_at = null;
		this.failed_dispatches = 0;

		if (source) {
			Object.assign(this, source);
		}
	}

	prepareForDispatch(now) {
		throw new Error(`Not implemented`);
	}
}

export default DispatchablePayload;
